import { API_PATH } from '@/shared/constants/api'
import { apiRequest } from '@/shared/helpers/api-request'

export function generateTelevetEmbeddedLink(
  token: string,
): Promise<{ url: string }> {
  return apiRequest<{ url: string }>(API_PATH.TELEVET_EMBEDDED_LINK, token)
}
